module.exports = __webpack_public_path__ + "static/media/filter-feature-family.3fd1d9d9.svg";